import React from 'react';
import { ResponsiveContainer, Scatter, ScatterChart } from 'recharts';

import colors from '@atom/styles/colors';
import { ConversationalAnalyticsChartProps } from '@atom/types/conversationalAnalytics';
import {
  CHART_HEIGHT,
  CHART_MARGINS,
} from '@atom/utilities/conversationalAnalyticsUtilities';

import useConversationalAnalyticsData from './hooks/useConversationalAnalyticsData';
import ConversationalAnalyticsChartAxes from './ConversationalAnalyticsChartAxes';
import ConversationalAnalyticsChartWrapper from './ConversationalAnalyticsChartWrapper';

const ConversationalAnalyticsSquareChart: React.FC<
  ConversationalAnalyticsChartProps
> = ({ spec, width = '100%', height, onExport }) => {
  const { chartData, xDisplayField, yField } =
    useConversationalAnalyticsData(spec);

  return (
    <ConversationalAnalyticsChartWrapper spec={spec} onExport={onExport}>
      <ResponsiveContainer width={width} height={height || CHART_HEIGHT}>
        <ScatterChart margin={CHART_MARGINS}>
          <ConversationalAnalyticsChartAxes spec={spec} />
          <Scatter
            data={chartData}
            fill={colors.brand.blue}
            dataKey={yField}
            name={xDisplayField}
            shape="square"
          />
        </ScatterChart>
      </ResponsiveContainer>
    </ConversationalAnalyticsChartWrapper>
  );
};

export default ConversationalAnalyticsSquareChart;
